// Dynamically determine the base URL based on current hostname
const BASE_URL = (() => {
  const hostname = window.location.hostname;

  const hostMap = {
    "thewinnerindia.com": "https://thewinnerindia.com",
  };

  // Return mapped URL if matched, otherwise construct dynamically
  if (hostMap[hostname]) return hostMap[hostname];

  // If running locally (localhost or 127.0.0.1)
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost";
    //return "https://admin.thewinnerindia.com";
  }

  // Default fallback (use same domain)
  return `https://${hostname}`;
})();

// Append /apis/ to the base URL
const API_BASE_URL = `${BASE_URL}/apis/`;

// SYSTEM_APIS
const SINGUP_API = `${API_BASE_URL}register/signup.php`;
const SINGIN_API = `${API_BASE_URL}register/signin.php`;
const FORGOT_PASSWORD = `${API_BASE_URL}forgetPassword.php`;
const CRUD_API_EDITPROFILE = `${API_BASE_URL}users/Edit_profile.php`;

//Store Fetch
const Fetch_product_catalogue = `${API_BASE_URL}Store/Fetch_product_catalogue.php`;
const Fetch_product_sub_catalogue = `${API_BASE_URL}Store/Fetch_product_sub_catalogue.php`;
const Fetch_product_products = `${API_BASE_URL}Store/Fetch_product_products.php`;
const Fetch_productDetails = `${API_BASE_URL}Store/Fetch_productDetails.php`;
const Fetch_newarrivals = `${API_BASE_URL}Store/Fetch_newArrivals.php`;
const Fetch_AllProducts = `${API_BASE_URL}Store/Fetch_AllProdctsView.php`;

//Orders
const Fetch_Orders_History = `${API_BASE_URL}Store/Fetch_orders.php`;

//Razorpay
const Payment_Gateway_Create_order = `${API_BASE_URL}PaymentGateway/create-order.php`;
const Payment_Gateway_Save_Order = `${API_BASE_URL}PaymentGateway/save-order.php`;
const Payment_Gateway_Save_payment = `${API_BASE_URL}PaymentGateway/save-payment.php`;
const Get_Razorpay_Config   = `${API_BASE_URL}PaymentGateway/Get_Razorpay_Config.php`;

//AdminAPIS

const SETTINGS_CRUD_API = `${API_BASE_URL}/settings/Settings_CRUD.php`;

const FetchUsers = `${API_BASE_URL}users/FetchUsers.php`;
const FetchUserDetails = `${API_BASE_URL}users/Fetch_userDetails.php`;
const Fetch_All_Orders = `${API_BASE_URL}users/Fetch_All_Orders.php`;

const FetchMedia = `${API_BASE_URL}assets/media.php`;
const ProductCatalogue = `${API_BASE_URL}ManageProducts/A_product_catalogue/product_catalogue.php`;
const ProductsSubCat = `${API_BASE_URL}ManageProducts/B_product_sub_catalogue/product_sub_catalogue.php`;
const Products = `${API_BASE_URL}ManageProducts/C_products/productsadd.php`;
const ProductVariants = `${API_BASE_URL}ManageProducts/D_product_variants/add_product_variant.php`;

const PRODUCT_LISTING = `${API_BASE_URL}ManageProducts/C_products/ProductList.php`;
const PRODUCT_UPDATE = `${API_BASE_URL}ManageProducts/C_products/Product_update.php`;
const BULK_PRODUCT_UPLOAD =`${API_BASE_URL}ManageProducts/C_products/bulk_products.php`;
export {
  // SYSTEM_APIS
  SINGUP_API,
  SINGIN_API,
  FORGOT_PASSWORD,
  CRUD_API_EDITPROFILE,

  //Store Fetch
  Fetch_product_catalogue,
  Fetch_product_sub_catalogue,
  Fetch_product_products,
  Fetch_productDetails,
  Fetch_newarrivals,
  Fetch_AllProducts,

  //Orders
  Fetch_Orders_History,

  //Razorpay
  Payment_Gateway_Create_order,
  Payment_Gateway_Save_Order,
  Payment_Gateway_Save_payment,Get_Razorpay_Config ,

  // Admin_apis
  SETTINGS_CRUD_API,
  FetchUsers,
  FetchUserDetails,
  Fetch_All_Orders,
  FetchMedia,
  ProductCatalogue,
  ProductsSubCat,
  Products,
  ProductVariants,
  PRODUCT_UPDATE,
  PRODUCT_LISTING,BULK_PRODUCT_UPLOAD,
};
